import { APIGetKongVXResponse, isValidKongId } from '@cyberkongz/api-interfaces';
import { fetchHttp, getSharedApiRoutes, getVxHeadImage } from '@cyberkongz/ui';
import { useKongVXEnhancedData } from '@cyberkongz/ui-blockchain';
import { KongVXPageView } from '@features/kongPage/KongVXPageView';
import { PageSEOTags } from '@features/seo/SEO';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { useAccount } from 'wagmi';

type PageProps = { data: APIGetKongVXResponse };

export async function getServerSideProps(
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<PageProps>> {
  const { id } = context.query;

  try {
    const idInt = parseInt(id as string, 10);

    if (!isValidKongId('vx', idInt)) {
      return {
        notFound: true,
      };
    }

    const data = await fetchHttp<APIGetKongVXResponse>(
      getSharedApiRoutes().GET_KONG_VX(parseInt(id as string, 10))
    );

    if (!data) {
      return {
        notFound: true,
      };
    }

    return { props: { data } };
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }
}

export default function KongPage({ data: { kong } }: PageProps) {
  const { id } = kong;
  const { isConnected } = useAccount();

  const { isOwner } = useKongVXEnhancedData(kong);

  return (
    <>
      <PageSEOTags
        title={`CyberKong VX ${id || ''} - CyberKongz VX`}
        imageUrl={getVxHeadImage(id)}
      />
      <KongVXPageView isOwner={isOwner} kong={kong} isConnected={isConnected} />
    </>
  );
}
